"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _personAdded = _interopRequireDefault(require("@atlaskit/icon/core/person-added"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AppAccessIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.98 5.98 0 0 1 10 17a6 6 0 0 1 2.682-5"/><circle cx="9" cy="7" r="4" fill="currentcolor"/><circle cx="16" cy="17" r="5" fill="currentcolor"/><path fill="inherit" d="M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
}, props, {
  newIcon: _personAdded.default
}));
AppAccessIcon.displayName = 'AppAccessIcon';
var _default = exports.default = AppAccessIcon;